import { render } from "./Leftmenu.vue?vue&type=template&id=4e10324b&scoped=true"
import script from "./Leftmenu.vue?vue&type=script&lang=js"
export * from "./Leftmenu.vue?vue&type=script&lang=js"

import "./Leftmenu.vue?vue&type=style&index=0&id=4e10324b&scoped=true&lang=scss"

import exportComponent from "D:\\phpstudy_pro\\gpt\\chatgpt-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e10324b"]])

export default __exports__